import { XIcon } from "@phosphor-icons/react";

/** «X» de la esquina superior derecha de las ventanas emergentes (mismo aspecto y comportamiento en todas). */
export default function BotonCerrar({ onClick, testid = "modal-cerrar", className = "" }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid} aria-label="Cerrar" title="Cerrar"
      className={`p-1.5 rounded-md text-text-muted hover:text-text-primary hover:bg-white/5 shrink-0 ${className}`}>
      <XIcon size={20} />
    </button>
  );
}
